import { useEffect, useState } from "react";
import CommercialHeader from "@/components/commercial/CommercialHeader";
import { api, fmtEur } from "@/lib/commercialApi";
import { Loader2 } from "lucide-react";

export default function ComStats() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/stats").then((r) => setD(r.data)); }, []);
  if (!d) return (
    <div className="min-h-screen bg-brand-paper"><CommercialHeader />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10"><Loader2 className="h-4 w-4 animate-spin text-brand-subtle" /></div>
    </div>
  );
  const rows = Object.entries(d.by_teleprospectrice || {});
  return (
    <div className="min-h-screen bg-brand-paper">
      <CommercialHeader />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-8">
        <div className="eyebrow mb-1">Performance commerciale</div>
        <h1 className="font-display text-3xl text-brand-ink mb-6">Statistiques</h1>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          <GlobalKpi label="Taux d'absence RDV" value={`${d.global.taux_absence} %`} />
          <GlobalKpi label="Taux de transformation" value={`${d.global.taux_transformation} %`} />
          <GlobalKpi label="Délai moyen signature" value={`${d.global.delai_moyen_signature_jours} jours`} />
          <GlobalKpi label="Panier moyen signé" value={fmtEur(d.global.montant_moyen_ventes)} />
        </div>

        <h2 className="font-display text-xl text-brand-ink mb-3">Par téléprospectrice</h2>
        {rows.length === 0 ? <div className="rounded-lg border border-brand-line bg-white p-8 text-sm text-brand-subtle text-center">Pas encore de données.</div>
        : (
          <div className="rounded-lg border border-brand-line bg-white overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-brand-paper text-left text-[11px] uppercase tracking-wider text-brand-subtle">
                <tr>
                  <th className="px-4 py-2.5">Téléprospectrice</th>
                  <th className="px-3 py-2.5 text-right">Appels</th>
                  <th className="px-3 py-2.5 text-right">Intéressés</th>
                  <th className="px-3 py-2.5 text-right">RDV</th>
                  <th className="px-3 py-2.5 text-right">Réalisés</th>
                  <th className="px-3 py-2.5 text-right">Absents</th>
                  <th className="px-3 py-2.5 text-right">Signés</th>
                  <th className="px-3 py-2.5 text-right">CA signé</th>
                  <th className="px-3 py-2.5 text-right">Commissions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-brand-line">
                {rows.map(([name, v]) => (
                  <tr key={name}>
                    <td className="px-4 py-2.5 font-medium text-brand-ink">{name}</td>
                    <td className="px-3 py-2.5 text-right font-mono">{v.appels}</td>
                    <td className="px-3 py-2.5 text-right font-mono">{v.interesses}</td>
                    <td className="px-3 py-2.5 text-right font-mono">{v.rdv}</td>
                    <td className="px-3 py-2.5 text-right font-mono">{v.rdv_realises}</td>
                    <td className="px-3 py-2.5 text-right font-mono">{v.rdv_absents}</td>
                    <td className="px-3 py-2.5 text-right font-mono">{v.signes}</td>
                    <td className="px-3 py-2.5 text-right font-mono">{fmtEur(v.ca_signe)}</td>
                    <td className="px-3 py-2.5 text-right font-mono">{fmtEur(v.commissions)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

function GlobalKpi({ label, value }) {
  return (
    <div className="rounded-lg border border-brand-line bg-white p-4">
      <div className="eyebrow">{label}</div>
      <div className="mt-2 font-display text-2xl text-brand-ink">{value}</div>
    </div>
  );
}
